import { useState, useEffect } from "react";
import { getJobTitlesConfig } from "../../../services/institutionSettings.service";

export const useJobTitlesInstitutionSetting = () => {
  const [config, setConfig] = useState({
    isEnabled: false,
    isRequired: false,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        const result = await getJobTitlesConfig();

        if (result) {
          if (result.kind && result.kind === "default") {
            setConfig({
              isEnabled: true,
              isRequired: false,
            });
          } else {
            if (result.value) {
              setConfig(result.value);
            }
          }
        }
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  return { config, loading, error };
};
